import React from 'react';

import styled from 'styled-components';
import { colors } from '../../styles/colors';
import { media } from '../../helpers/mediaHelper';

const StyledLabel = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: ${colors['gray']['9']};

  ${media.mobile`
    font-size: 16px;
    line-height: 24px;
  `};
`;

const StyledValue = styled(StyledLabel)`
  color: ${colors['gray']['7']};
  line-height: 24px;
`;

const ReviewItem = ({ label, children }) => {
  return (
    <>
      <StyledLabel>{label}</StyledLabel>
      <StyledValue>{children}</StyledValue>
    </>
  );
};

export { ReviewItem };
